export default __webpack_public_path__ + "static/media/404-error-pana.659837e4.svg";